import { render, staticRenderFns } from "./mathchooseType.vue?vue&type=template&id=571a552a&scoped=true&"
import script from "./mathchooseType.vue?vue&type=script&lang=js&"
export * from "./mathchooseType.vue?vue&type=script&lang=js&"
import style0 from "./mathchooseType.vue?vue&type=style&index=0&id=571a552a&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571a552a",
  null
  
)

export default component.exports